import moment from 'moment'
import miscStore from '../store/misc.js'
import logStore from '../mixins/logMixin'
// import axios from 'axios'
import axiosInstances from '../server/axiosInstances'
import querystring from 'querystring'
import cache from './cache'
// import Vue from 'vue'

function mathTotal(ar, field) {
  return ar.reduce((sum, i) => sum += Number(i[field]),0)
}

function cacheModules (m) {
  return
  console.log('caching ', m)
  switch (m) {
    case 'Dashboards':
    break
    case 'Automation':
    break
    case 'CRM':
      // cache.preload(['crm_company','crm_contacts','crm_sales','crm_lic_cart', 'crm_sales_inter'])
    break
    case 'Cultivation':
      // cache.preload(['cul_wodefs', 'cul_workorders',
      // 'cul_harvest', 'cul_plantings', 'cul_products', 'cul_sales', 'cul_scheduler',
      // 'cul_supplies', 'cul_tasks', 'cul_trim', 
      // 'cul_waste_cart', 'cul_nutrient_cart'])
    break
    case 'Distribution':
      //cache.preload(['dis_products', 'dis_inventory', 'dis_sales', 'dis_tasks', 'dis_sales_cart',
      //'dis_report_templates'])
    break
    case 'POS':
      //cache.preload(['pos_sales', 'pos_sales_cart', 'pos_inventory', 'pos_products', 'pos_report_templates'])
    break
    case 'Manufacturing':
      //cache.preload(['mfg_inventory', 'mfg_products', 'mfg_sales', 'mfg_tasks', 'mfg_sales_cart', 'mfg_scheduler', 'mfg_wodefs','mfg_recipes'])
    break
    case 'Testing':
      //cache.preload(['tes_cart'])
    break
    case 'Taxes':
      //cache.preload(['tax_details','tax_inventory', 'tax_payments'])
    break
    case 'Metrc':
    break
    case 'Settings':
    break
    case 'Analytics':
    break

  }
}

function cellFilter (val, filter, extra) {
  // console.log('cellFilter: ', val, filter)
  // console.log('cell val,filter,extra =', val, filter, extra)
  // check if filter is a function
  if (Array.isArray(val)) {
    if (val.length > 0 && typeof val[0] === 'object') {
      //kluge - fix it!
      if (val[0].subtotal) {
        return mathTotal(val, 'subtotal')
      }
      if (val[0].value) {
        return mathTotal(val, 'value')
      }
      if (val[0].numitems) {
        return val.length + ' items'
      }
    }
      // return 'Click to expand/collapse'
  }
  if (filter == undefined) return val
  var isfunc = (typeof filter === 'function')
  if (isfunc) {
    return filter(val)
  } else {
    if (val == null || filter == null) return val
    const [field, format] = filter.split('?')
    switch (field) {
      case 'filter':
        let table = format.split(':')
        let obj = cache.getCachedObject(table[0], val)
        if (!obj) {
          if (!cellFilter[table[0]]) {
            // await cache.cacheTable(table[0])
            cellFilter[table[0]] = true
          }
          return val
        }
        let args = table[1].split(',')
        let val1 = val
        if (args[0]) {
          val1 =  obj[args[0]]
        }
        if (args[1]) {
          val1 = val1 + ' (' + obj[args[1]] + ')'
        }
        return val1
      case 'measure':
        return val.qty+' '+val.unit
      case 'object':
        if (!extra) return val
        let editables = extra[0]
        let ed = editables.filter(i => i[format] == extra[1])
        if (ed.length < 1) return val
        let l = ed[0].listItems
        let v = l.filter(i => i.value == val)
        if (v.length > 0) return v[0]['display']
        return val
      case 'date':
        return moment(val).format(format)
      case 'daysSince':
        var day1 = moment(val)
        var day2 = moment()
        var days = moment.duration(day1.diff(day2)).asDays()
        return(days)
      case 'time':
        return moment(val, 'H:mm').format(format)
      case 'trim':
        let ll = 12 // parseInt(format)
        if (val.length <= ll) return val
        var lx = ll - 3
        return v.substring(0,3) + '...' + v.slice(3 - lx)
      default:
        return val
    }
  }
}

function initDialogState (t) {
  t.dialogOpen = false, // to open and close the main dialog attached to table
  t.editables = [],
  t.dialogTitle = 'Dialog', // title of dialog
  t.dialogDefaultItem = {},
  t.dialogEditedItem = {}, // the edited Item
  t.dialogGetRemote = null, // the function to be called if a field is marked remote callable
  t.dialogRemoteTitle = 'REMOTE',
  t.dialogEditIndex = -1,
  t.dialogSaveCallback = null, // function to callback when saving from dialog
  t.dialogSubEdit = false,
  t.dialogSavedState = {},
  t.dialogStateIsSaved = false,
  t.dialogExpandedId = null,
  t.dialogIsFullPage = true,
  t.dialogFunctions = {}
}



function resetCallbackFunctions () {
  store.state.dialogDeleteCallback = null
  store.state.callbackNew = null
}

function resetTableDefaults () {
  resetCallbackFunctions()
  store.state.showActionsTitle = true
  store.state.showViewer = false
  store.state.allowExpansion = false
  store.state.rowClickFunction = false
  store.state.tableShowAddButton = true
  store.state.tableShowMoreButtons = true
  store.state.tableShowDeleteButtons = true
  store.state.tableShowEditButtons = true
  store.state.tableAddButtonName = 'add'
}

function phraseMap(key) {
  let map = miscStore.state.phraseMap
  var result = map.filter(obj => obj.key == key)
  if (!result || result.length < 1) return key
  return result[0][miscStore.state.language]
}



async function fetchFilteredTable (tablename, params) {
  var queryString = querystring.stringify(params)
  var table
  var query = '/dt/v1/' + tablename + '?' + queryString
  try {
    table = await axiosInstances.apiServer.get(query)
    return table.data
  } catch (ex) {
    console.log(ex)
    table = []
    return table
  }
}


function convertUnits(from, to) {
  switch(from) {
    case 'oz':
      switch(to) {
        case 'oz': return 1
        break
        case 'lb': return .0625
        break
        case  'g': return 28.3495
        break
        default: return -1
      }
      break
    case 'lb':
    switch(to) {
      case 'oz': return 16
      break
      case 'lb': return 1
      break
      case  'g': return 453.592
      break
      default: return -1
    }
      break
    case 'g':
    switch(to) {
      case 'oz': return .035274
      break
      case 'lb': return .00220462
      break
      case  'g': return 1
      break
      default: return -1
    }
      break

  }
}


function mergeArrays (a, b, replace) {
  let c = []
  a.forEach(i => {
    let b_item
    let key = i.key
    let b_filtered = b.filter(j => j.key == key)
    if (b_filtered.length > 0) b_item = b_filtered[0]
    let c_item = replace ? b_item : Object.assign({}, i, b_item)
    c.push(c_item)
  })
  b.forEach(j => {
    let key = j.key
    let a_filtered = a.filter( i => i.key == key)
    if (a_filtered.length < 1) {
      c.push(j)
    }
  })
  return c
}

function parseField(f, display) {
  if (!f) return f
  let c = {}

  if (!f.includes(':')) return f
  let commands = f.split(';')
  if (display) return commands[0]
  let args
  commands.forEach(cmd => {
    let c1 = cmd.split(':')
    if (c1[1]) {
      args = c1[1].split('-')
      c[c1[0]] = args.map(i => i.split(','))
    } 
  })
  return c
}

function displayFormat(v, type) {
  if (typeof type === 'undefined') type = 'string'
  if (typeof type !== 'string') type = type[0][0]
  switch(type) {
    case 'currency':
      v  = Number(v)
      return toCurrency(v)
    case 'measure':
      return Number(v.qty).toLocaleString() + ' ' + v.unit
    case 'date':
      return moment(v).format('MM/DD/YYYY hh:mm A')
    case 'dateWSeconds':
      return moment(v).format('MM/DD/YYYY hh:mm:ss A')
    case 'dateOnly':
      return moment(v).format('MM/DD/YYYY')
    case 'daysSince':
        var day1 = moment(v)
        var day2 = moment()
        var days = Math.floor(moment.duration(day2.diff(day1)).asDays())
        return(days)
    case 'tax':
      return toCurrency(Number(v.a))
    case 'check':
      return ''
    case 'trim':
      let ll = 12 // parseInt(format)
      if (v.length <= ll) return v
      var lx = ll - 3
      return v.substring(0,3) + '...' + v.slice(3 - lx)
    case 'pdf':
    case 'image':
      return '' // for pdf files, let the icon be enough
    default: return v
  }
}

async function formatSingleField(field, table, type) {
  // let t = store.state.translator.filter(i => i.key == table)[0]['keys']
  let t = axiosInstances.loginServer.get('/dt/v1/'+table)
  t = t.filter(i => i.key === type)[0]
  return displayFormat(field, t.type)
}

// async function getObjectFromID(id, table, fields) {
//   let obj = await cache.getObject(table, id)
//   let begin = fields[0]
//   fields.shift()
//   if (fields.length < 1) return obj[begin]
//   return  obj[begin] + fields.reduce((start, i) => {
//     return start + formatSingleField(obj[i], table, i) + ' ' 
//   },  ' ( ') + ' )'
// }

function getArrayToolTip(item, table) {
  let t = cache.getCachedTable(table, true)
  var str = '<table style="border-collapse: collapse">'
  var ret = item.reduce((r, i) => {
    r += '<tr>'
    Object.keys(i).forEach((k, idx) => {
      let schema = t.filter(s => s.key === k)[0]
      r += '<td style="padding: 3px; border: 1px solid">'
      r += schema.type === 'currency' ? toCurrency(Number(i[k])) : i[k] 
      r += '</td>'
    })
    r += '</tr>'
    return r
  }, str)
  return ret
}

function processArray(item, cmd, t, arrayTable) {
  if (t) return getArrayToolTip(item, arrayTable)
  let op = cmd.reduce[0][0]
  let field = cmd.reduce[1][0]
  switch (op) {
    case 'sum':
      return item.reduce((sum, i) => {
          return sum + Number(i[field])
        }, 0)
    case 'max', 'min':
      return Math[op].apply(null, item.map(i => i[field]))
  }
}

function toCurrency(v) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  return !v || typeof v !== 'number' ? isNaN(v) ? '' : v : formatter.format(v)
}

function resolveObjectRecursion(id, table, field) { 
  let nextid = cache.getCachedObject(table[0], id)
  let v = ''
  if (!nextid) {
    // logStore.methods.elog('debug', 'Object recursion can not be resolved: {} {}', id, table[0])()
    return v
  }
  field.forEach(async function(f) {
      v += nextid[f] + ','
  })
  return v
}

function getValueFromID(v, table, fields) {
  let pre = resolveObjectRecursion(v, table, fields)
  let post = formatMultiDisplay(pre)
  return post
}

function formatMultiDisplay (str) {
  if (!str) return null
  let t = str.split(',')
  t = t.filter(i => i !== '')
  return t.join(' - ')
}

function displayFilter (v, filter) {
  let f = filter[0][0]
  switch (f) {
    case 'uc':
      v = v.toUpperCase()
      break
  }
  return v
}

// async 
function formatItem(item) {
  // i = item, h = header, e = editables
  // t = return tooltip, a = return whether this item should have click
  // c = click action values
  let i = item.i, h = item.h, e = item.e, t = item.t, a = item.a
  if (!h || !i) return
  
  let v = i[h.value]
  if (!v) return
  if (t && !h.format) return null
  if (!h.format) return v
  let cmd = parseField(h.format)
  e = e.filter(i => i.name === h.value)[0]
  if (a) {
    if (cmd.action && cmd.action[0][0] == 'click' && cmd.action[1][0] == 'expand') {
      item.c[h.value] = {t:'array', u:'mdi-arrow-expand-up', d: 'mdi-arrow-expand-down'}
      return true
    } else if (cmd.action && cmd.action[0][0] == 'click' && cmd.action[1][0] == 'file') {
      console.log(cmd)
      if (!cmd.filter[0]) return true
      switch (cmd.filter[0][0]) {
        case 'pdf':
        item.c[h.value] = {t:'file', u:'mdi-file-pdf-box', d:'mdi-file-pdf-box'}
          break
        case 'image':
        item.c[h.value] = {t:'file', u:'mdi-image', d: 'mdi-image'}
          break
      }
      return true
    } else if (cmd.action && cmd.action[0][0] == 'click' && cmd.action[1][0] == 'check') {
      item.c[h.value] = {t:'check', u:'mdi-checkbox-blank-outline', d:'mdi-checkbox-marked'}
      return true
    }
  }
  if (t) {
    //only return tooltip for certain type of objects
    if (cmd.filter[0][0] === 'tax') {
      switch(v.s) {
        case 't': return 'Pending'
        case 'd': return 'Due'
        case 'p': return 'Paid'
        default: return ''
      }
    }
    switch (cmd.type[0][0]) {
      case 'array':
        let pa = processArray(v, cmd, t, e['arrayTable'])
        return pa
      default:
        return null
    }
  }
  switch (cmd.type[0][0]) {
      case 'self':
        break
      case 'key':
        v = i[cmd.type[1]]
        break
      case 'id':
        let table = cmd.filter[0]
        let fields = cmd.filter[1]
        v = getValueFromID(v, table, fields) // getObjectFromID(v, table, fields)
        break
      case 'array':
        v = processArray(v, cmd, t, e['arrayTable'])
        break
      default:
  }
  v = displayFormat(v, cmd.filter)
  // if there is any display filter, apply it now
  if (cmd.df) {
    v = displayFilter(v, cmd.df)
  }
  return v
}

//for now, an ineffeicient way?
function deepCopy(item) {
  return JSON.parse(JSON.stringify(item))
}

async function generateUniqueTag(tableName, field, prefix, digits) {
  if (!digits) digits = 4
  let table = await cache.getTable(tableName)
  if (!table || table.length < 1) {
    return prefix + '1'.padStart(digits,'0')
  }
  let tag = table.reduce((max, item) => parseInt(item[field].substring(digits), 10) > max ? 
    parseInt(item[field].substring(digits), 10) : max, 0) + 1
  return prefix + tag.toString().padStart(digits,'0')
}

async function getSensorReading() {
  var self = this
  var k
  let vals = []
  store.state.orgSensors.forEach(async function(item) {
    if (item.type !== 'sensor' ) return
    var labels = []
    k = await axiosInstances.apiServer.get('/dt/v1/' + item.deviceID + '?last=1')
    if (!k.data) return
    let keys = Object.keys(k.data[0].data)
    labels = keys.map(function(k) {
      let idx = store.state.dictionary.findIndex(p => p.code == k)
      return store.state.dictionary[idx].label
    })
    var newval = []
    keys.forEach(function(key) {
      newval.push(k.data[0].data[key])
    })
    let idx = self.rows.findIndex(p => p.deviceid == item.deviceID)
    if (idx == -1) {
      self.rows.push(
        {
          deviceid: item.deviceID,
          deviceName: item.deviceName,
          location: item.location,
          sensors: keys,
          // date: '12345',
          labels: labels.join(', '),
          value: newval
        }
      )
    } else {
      self.rows[idx].value = newval
    }
  })
}

async function getImage(fname) {
  let orgname = localStorage.getItem('uid')
  if (!orgname) return null
  try {
    var url = '/getfiles/'+this.org.name+'/'+fname
    let image = await axiosInstances.apiServer.get(url,{responseType: 'arraybuffer'})
    return image
  } catch (ex) {
    console.log(ex)
    return null
  }
}

async function cacheObjectReferences(table, headers) {
  await Promise.all(headers.map(async (h) => {
    let p = utils.parseField(h.format)
    if (p && p.type && p.type[0][0] == 'id') {
      // tables.push(p.filter[0])
      await cache.cacheTable(p.filter[0])
    }
  }));
  return 
}

async function create_schema () {
  let names = await axiosInstances.authServer.get('/dt/v1/translator?return=key')
  names = names.data.map(i => i.key)
  names.forEach(async function(name) {
    let table = await axiosInstances.authServer.get('/dt/v1/translator?return=keys&key='+name)
    if (table == null || table.data == null) return
    try {
      await axiosInstances.loginServer.delete('/dt/v1/collections/sch_'+name)
    } catch {
    }
    await axiosInstances.loginServer.post('/dt/v1/bulkupload/sch_'+name+'?org=auth&id=new', table.data[0].keys)
  })
}

const utils = {
  cellFilter,
  cacheModules,
  resetCallbackFunctions,
  resetTableDefaults,
  fetchFilteredTable,
  convertUnits,
  phraseMap,
  mergeArrays,
  deepCopy,
  formatItem,
  parseField,
  getValueFromID,
  generateUniqueTag,
  toCurrency,
  getSensorReading,
  getImage,
  cacheObjectReferences,
  create_schema,
  displayFormat
}

export default utils
